export class DisplayMode {
    public static readonly AddMode = 'A';
    public static readonly EditMode = 'E';
    public static readonly DisplayMode = 'D';
}
